import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import  {GET, POST}  from '../../services/api';
import axios from "axios";

// Define the async thunk for the GET request
export const AuthAction = createAsyncThunk('data/auth', async (data, { rejectWithValue }) => {

  try {
    const response = await POST(`/admin/auth/session`, data);
    if (response?.status === 200) {
      return response.data.result; // Assuming the response is in data property
    } else {
      return rejectWithValue(response?.data || "Something went wrong");
    }
  } catch (error) {
    return rejectWithValue(error?.response?.data || "Failed to fetch data");
  }

}

);



export const verifyOtpAction = createAsyncThunk(
  "auth/verifyOtp",
  async ({ otp, sessionId }, { rejectWithValue }) => {
    try {
      // const headers = {
      //   Authorization: `Bearer ${sessionId}`, // Passing sessionId as a token in headers
      //   "Content-Type": "application/json",
      // };

      const response = await axios.post(
        "/admin/auth/otp/verify",
        { otp },  // Request body
        { sessionId } // Headers
      );

      if (response?.status === 200) {
        return response.data.result; // Assuming success response contains result
      } else {
        return rejectWithValue(response?.data || "Invalid OTP");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "OTP verification failed");
    }
  }
);






export const forgotPasswordAction = createAsyncThunk(
  "auth/forgotPassword",
  async (data, { rejectWithValue }) => {
    try {
      const response = await POST(`/admin/auth/password/forgot`, data);
      if (response?.status === 200) {
        return response.data; // Return success response data
      } else {
        return rejectWithValue(response?.data || "Something went wrong");
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || "Failed to send password reset request");
    }
  }
);

// View Home Category
export const viewAdminProfile = createAsyncThunk(
  "admin/viewProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(`/admin/auth/profile`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "An error occurred while fetching profile");
    }
  }
);




const AuthSlice = createSlice({
  name: 'auth',
  initialState: {
    authData: [],
    AuthLoading: false,
    AuthError: null,
    viewProfile: "",
    viewProfileLoading: false,
    viewProfileError: null,
    forgetData: [],
    forgetLoading: false,
    forgetError: null,
    verifyData: [],
    verifyOtpActionLoading: false,
    verifyError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AuthAction.pending, (state) => {
        state.AuthLoading = true;
        state.AuthError = null;
      })
      .addCase(AuthAction.fulfilled, (state, action) => {
        state.AuthLoading = false;
        state.authData = action.result;
      })
      .addCase(AuthAction.rejected, (state, action) => {
        state.AuthLoading = false;
        state.AuthError = action.error.message;
      });

      builder
      .addCase(forgotPasswordAction.pending, (state) => {
        state.forgetLoading = true;
        state.forgetError = null;
      })
      .addCase(forgotPasswordAction.fulfilled, (state, action) => {
        state.forgetLoading = false;
        state.forgetData = action?.payload.result?.token;
      })
      .addCase(forgotPasswordAction.rejected, (state, action) => {
        state.forgetLoading = false;
        state.forgetError = action.error.message;
      });

      builder
      .addCase(viewAdminProfile.pending, (state) => {
        state.viewProfileLoading = true;
        state.viewProfileError = null;
      })
      .addCase(viewAdminProfile.fulfilled, (state, action) => {
        state.viewProfileLoading = false;
        state.viewProfile = action?.payload.result;
      })
      .addCase(viewAdminProfile.rejected, (state, action) => {
        state.viewProfileLoading = false;
        state.viewProfileError = action.error.message;
      });



      builder
      .addCase(verifyOtpAction.pending, (state) => {
        state.verifyOtpActionLoading = true;
        state.verifyError = null;
      })
      .addCase(verifyOtpAction.fulfilled, (state, action) => {
        state.verifyOtpActionLoading = false;
        state.verifyData = action.result;
      })
      .addCase(verifyOtpAction.rejected, (state, action) => {
        state.verifyOtpActionLoading = false;
        state.verifyError = action.error.message;
      });
  },
});

export default AuthSlice.reducer;
